import acceptOrderInfo from './acceptOrderInfo'
import dataImportInfo from './dataImportInfo'
import home from './home'
import master from './master'
//import numberInfo from './numberInfo'
import orderInfo from './orderInfo'
import reportInfo from './reportInfo'
import systemSetting from './systemSetting'

export default [home, /*...numberInfo,*/...dataImportInfo,...acceptOrderInfo, ...orderInfo, ...reportInfo, ...master,...systemSetting]

